import React from "react"
import { FormattedMessage, injectIntl, FormattedNumber } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Addon, { AddonDto } from "../state/billing/Addon"

type OwnProps = {
    formatPrice: (price: string) => number,
    currency: string,
    addons: AddonDto[],
    selectedAddonsMap: object,
    intervalType: string,
    priceWithExtraAddons: number,
}

function ExtraAddon(props: OwnProps) {
    const addonsArray = props.addons.map((ad): Addon => new Addon(ad as AddonDto))
    return (<div>
        {addonsArray.filter(ad =>
            ad.getAttributes().modifiedQMAttribute && Object.keys(props.selectedAddonsMap).includes(ad.getId()))
            .map((a, i) => <div key={i} className="d-inline-flex mt-3 mb-3">
                <FormattedMessage
                    id="myaccount.choose_plan.estimate_total_extra_addon_details"
                    defaultMessage="+ {priceOfAddon} X {quantityOfAttribute} {nameOfAttribute}"
                    values={{
                        nameOfAttribute: a.getAddonName(AppContext.getAccount().attributes.defaultLanguage),
                        priceOfAddon: <div className="d-inline-flex mr-1">
                            <FormattedNumber
                                style="currency"
                                maximumFractionDigits={0}
                                currencyDisplay={"symbol"}
                                currency={props.currency}
                                value={props.formatPrice(a.getAttributes().price)}
                            />
                        </div>,
                        quantityOfAttribute: <div className="d-inline-flex mr-1">
                            <FormattedNumber
                                style="percentage"
                                value={props.selectedAddonsMap[a.getId()]}
                            />
                        </div>,
                    }}
                />
            </div>)}
    </div>)
}

export default injectIntl(ExtraAddon)


// WEBPACK FOOTER //
// ./src/my-account/extraAddonsTotal.tsx